module.exports = __webpack_public_path__ + "img/indonesia-independence-day.d36b9db4.png";